module.exports = __webpack_public_path__ + "img/photozone-1.7eaebf1f.webp";